import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {ModalBody, ModalFooter, ModalHeader, ModalTitle} from '@/components/ui/modal-atoms/ModalAtoms'

export const MedicalReportDetailsModalLoader = () => {
    return (
        <>
            <ModalHeader>
                <Flexbox direction="column" gap={2}>
                    {/* Modal title skeleton */}
                    <ModalTitle>
                        <Skeleton width={300} height={32} />
                    </ModalTitle>

                    {/* MedicalReportDetailsHeading skeleton */}
                    <Grid columns={3} gap={3}>
                        {/* Report date field */}
                        <Flexbox direction="column" gap={1}>
                            <Skeleton width={120} height={16} />
                            <Skeleton width={100} height={14} />
                        </Flexbox>

                        {/* Created by field */}
                        <Flexbox direction="column" gap={1}>
                            <Skeleton width={150} height={16} />
                            <Skeleton width={120} height={14} />
                        </Flexbox>

                        {/* Notes field (conditional) */}
                        <Flexbox direction="column" gap={1}>
                            <Skeleton width={80} height={16} />
                            <Skeleton width={200} height={14} />
                        </Flexbox>
                    </Grid>
                </Flexbox>
            </ModalHeader>

            <ModalBody>
                {/* Content area skeleton - iframe or loading state */}
                <Skeleton width={960} height={500} />
            </ModalBody>

            <ModalFooter>
                <Flexbox justify="space-between" fullWidth>
                    {/* Close button skeleton */}
                    <Skeleton width={80} height={32} />

                    {/* Action buttons skeleton */}
                    <Flexbox align="center" gap={2}>
                        <Skeleton width={80} height={32} />
                        <Skeleton width={80} height={32} />
                    </Flexbox>
                </Flexbox>
            </ModalFooter>
        </>
    )
}
